import React from "react";
import carousleBg from "../../assests/carousleBg.svg";

export default function PromotorsInCarousel({
  promoters,
  scrollRef,
  setPromoterPopup,
  setPromoterDetails,
}) {
  var coverStyle = {
    background: `url(${carousleBg}) center center/contain no-repeat,linear-gradient(81.11deg, rgba(86, 86, 86, 0.4) 25.51%, rgba(21, 21, 21, 0.4) 74.24%) `,
  };
  const handleClickPromoter = (obj) => {
    setPromoterDetails(obj);
    setPromoterPopup(true);
  };

  return (
    <div
      style={coverStyle}
      ref={scrollRef}
      className="h-[194px] w-[320px] shrink-0 flex-grow flex flex-col  items-center p-[20px]"
    >
      <p className="text-regular-medium mb-[10px]">Promoters</p>
      <div className=" flex justify-around gap-[3%] w-[100%]">
        {promoters?.slice(0, 4)?.map((promotor) => {
          return (
            <div
              className="flex flex-col items-center justify-center w-[25%] text-center"
              onClick={() => handleClickPromoter(promotor)}
            >
              <img
                src={promotor?.dop}
                className="rounded-full w-[60px] h-[60px] object-cover mb-[9px]"
              />
              <p className="text-smallest text-[#CDCDCD]   w-[100%]">
                {promotor?.promotorName}
              </p>
              <p className="text-smallest2 text-[#606060] truncate w-[100%]">
                {promotor?.position}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
